import {
    DatiqAnalyticsActionTypes,
    DatiqAnalyticsInputInteraction,
    DatiqAnalyticsTrackingEventKeys,
} from './datiq-analytics.enum';
import {
    IDatiqAnalytics,
    IDatiqAnalyticsConfig,
    IDatiqAnalyticsEvent,
    IDatiqAnalyticsEventInputInfo,
    IDatiqAnalyticsEventTrack,
    IDatiqAnalyticsEventTrackRow,
    IDatiqAnalyticsMatchingEvent,
} from './datiq-analytics.interface';

export const emptyDatiqAnalyticsEventInputInfo: IDatiqAnalyticsEventInputInfo = {
    inputId: '',
    label: '',
    interaction: DatiqAnalyticsInputInteraction.Unknown,
};

export const emptyDatiqAnalyticsEvent: IDatiqAnalyticsEvent = {
    eventName: '',
    inputInfo: { ...emptyDatiqAnalyticsEventInputInfo },
};

export const emptyDatiqAnalyticsEventTrackRow: IDatiqAnalyticsEventTrackRow = {
    [DatiqAnalyticsTrackingEventKeys.GlobalId]: '',
    [DatiqAnalyticsTrackingEventKeys.PreImplementationStatus]: '',
    [DatiqAnalyticsTrackingEventKeys.ChangeType]: '',
    [DatiqAnalyticsTrackingEventKeys.Id]: '',
    [DatiqAnalyticsTrackingEventKeys.Ticket]: '',
    [DatiqAnalyticsTrackingEventKeys.Status]: '',
    [DatiqAnalyticsTrackingEventKeys.Priority]: '',
    [DatiqAnalyticsTrackingEventKeys.Initiator]: '',
    [DatiqAnalyticsTrackingEventKeys.EventName]: '',
    [DatiqAnalyticsTrackingEventKeys.Page]: '',
    [DatiqAnalyticsTrackingEventKeys.Location]: '',
    [DatiqAnalyticsTrackingEventKeys.TrackingType]:
        DatiqAnalyticsActionTypes.Unknown,
    [DatiqAnalyticsTrackingEventKeys.SpecificProperties]: '',
};

export const emptyDatiqAnalyticsEventTrack: IDatiqAnalyticsEventTrack = {
    row: { ...emptyDatiqAnalyticsEventTrackRow },
    analyticEvent: { ...emptyDatiqAnalyticsEvent },
};

export const emptyDatiqAnalytics: IDatiqAnalytics = {
    trackingEvents: [] as IDatiqAnalyticsEventTrack[],
    loaded: false,
};

export const emptyDatiqAnalyticsConfig: IDatiqAnalyticsConfig = {
    trackingEvents: [] as IDatiqAnalyticsEventTrack[],
};

export const emptyDatiqAnalyticsMatchingEvent: IDatiqAnalyticsMatchingEvent = {
    trackingEvent: { ...emptyDatiqAnalyticsEventTrack },
    analyticsEvent: { ...emptyDatiqAnalyticsEvent },
};
